<template>
	<div class="user-display-name" :class="{ support: isSupport }">
		{{ displayName }}
		<BadgeCheckIcon v-if="isSupport" class="verified-icon" type="solid" />
	</div>
</template>

<script>
import { BadgeCheckIcon } from '@/icons'

export default {
	name: 'UserName',
	components: { BadgeCheckIcon },
	props: {
		user: {
			type: Object,
			default: null,
		},
	},

	computed: {
		displayName() {
			if (!this.user) return
			return this.user.fullname
				? this.user.fullname
				: `${this.user.firstname} ${this.user.lastname}`
		},
		isSupport() {
			return this.user?.isSupportUser || this.user.role === 'support' || false
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.user-display-name {
	display: inline-flex !important;
	align-items: center;
}

.verified-icon {
	color: $pronto-blue !important;
	margin-left: 6px;
}
</style>
